BaseStore = require 'stores/BaseStore'
ActionTypes = require 'constants/ActionTypes'
deepcopy = require 'deepcopy'
{ FOR_DASHBOARD } = require 'constants/Agents'

class ConversationsDashboardStore extends BaseStore
  constructor: ->
    super()
    @conversations = []
    @conversationsHash = {}
    @agents = {}
    @sales = {}
    @csr = {}
    @state =
      errors: null
      loading: false
    @registerActions()

  onConversationsRequest: () ->
    @state.loading = true
    @conversationsHash = {}
    @conversations = []
    @emitChange()

  onConversationsUpdating: (payload) ->
    Object.keys(payload.message).forEach (id) =>
      if payload.message[id]
        @conversationsHash[id] ||= {}
        Object.keys(payload.message[id]).forEach (key) =>
          @conversationsHash[id][key] = payload.message[id][key]
      else
        delete @conversationsHash[id]
    @conversations = Object.keys(@conversationsHash).map (key) =>
      if !@conversationsHash[key].last_message && @conversationsHash[key].last_reminder
        @conversationsHash[key].status = 'inactive'
      if !@conversationsHash[key].agents
        @conversationsHash[key].status = 'unassigned'
      @conversationsHash[key]
    agents = {}
    @sales = {}
    @csr = {}

    _.each @conversations, (conversation) =>
      _.each conversation.agents, (agent) =>
        agents[agent.id] ||= deepcopy(agent)
        agents[agent.id][conversation.status] ||= 0
        agents[agent.id][conversation.status] += 1
        if agent.role == 'sales'
          @sales['total'] ||= 0
          @sales['total'] += 1
          @sales[conversation.status] ||= 0
          @sales[conversation.status] += 1
        else if FOR_DASHBOARD.includes agent.role
          @csr['total'] ||= 0
          @csr['total'] += 1
          @csr[conversation.status] ||= 0
          @csr[conversation.status] += 1

    @agents = agents
    @state.loading = false if payload.initial
    @emitChange()

  _registerToActions: ({ type, payload }) =>
    switch type
      when ActionTypes.MQTT_DASHBOARD_CONVERSATIONS_REQUEST
        @onConversationsRequest()
      when ActionTypes.MQTT_DASHBOARD_CONVERSATIONS_UPDATING_INITIAL
        @onConversationsRequest()
      when ActionTypes.MQTT_DASHBOARD_CONVERSATIONS_UPDATING
        @onConversationsUpdating(payload)

module.exports = new ConversationsDashboardStore()
